import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Box,
    Button,
    Collapse,
    FormControl,
    Grid,
    IconButton,
    TableContainer,
    TextField,
    Typography
} from "@mui/material";
import { ReactComponent as CloseIcon } from "assets/images/CloseIcon.svg";
import ErrorIcon from "assets/images/warning-2.svg";

import { CircularLoaderFullPage } from "components/core";

import { ExpandMore } from "@mui/icons-material";
import SuccessPopup from "components/core/success-popup/SuccessPopup";
import dayjs from "dayjs";
import { t } from "i18next";
import MUIDataTable from "mui-datatables";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomerByID, getMessageFromCode } from "services/api/query";
import { selectAuth } from "store/slices";
import {
    setDefaultBranchValues,
    setIsRefreshRequired
} from "store/slices/customer-preferences";
import spacing from "styles/spacing";
import {
    dayMonthYearTimeFormat,
    ERROR_TYPES,
    errorMsgs,
    ROLE_ACCESS_CODES
} from "utils/constants";
import {
    preferencesTypeIds,
    systemId
} from "utils/constants/customer-information/CustomerPreference";
import {
    dateTimeFormatByLocalewithSeconds,
    findErrorMessage,
    handleSystemErrorDataDogLog
} from "utils/helpers";
import PreferencesLayout from "../preferences-main/PreferencesLayout";
import {
    getCustomerPreferenceHistory,
    getPreferenceTabValues,
    updateCustomerPreferences
} from "../preferences-main/Services";
import { AddCutOffDeadlineTableColumns, tableOptions } from "../preferences-main/TableColumns";
import { PreferencesStyles } from "../PreferencesStyles";

const SpacialSla = () => {
    const { roleAccess, timeZoneOffset, localeByBranch } =
        useSelector(selectAuth);
    const location = useLocation();
    const stateData = location.state;

    const [isLoading, setIsLoading] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [spacialSlaValue, setSpacialSlaValue] = useState("");
    const [initialValue, setInitialValue] = useState("");
    const [tableData, setTableData] = useState([]);
    const [throwErrorMessage, setThrowErrorMessage] = useState("");
    const [throwError, setThrowError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [validationFailed, setValidationFalied] = useState(false);
    const [isDisabled, setIsDisabled] = useState({
        spacialSlaField: false
    });
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { defaultAuthBranchValues, isAuthenticated } = useSelector(
        (state) => state.customerPreferences
    );
    const redirecToPreviousPage = () => {
        navigate(-1);
        const updatedData = {
            ...defaultAuthBranchValues,
            isDisablePrint: false
        };

        dispatch(setDefaultBranchValues(updatedData));
    };
    const getSelectedCustomer = async (customer_id) => {
        setIsLoading(true);
        try {
            const customer = await getCustomerByID(customer_id);
            setSelectedCustomer(customer[0]);
        } catch (error) {
            let message = handleSystemErrorDataDogLog(error);
            setThrowErrorMessage(message);
            setThrowError(true);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (stateData?.customer_id) getSelectedCustomer(stateData?.customer_id);
    }, [stateData?.customer_id]);

    const timeOptions = [];
    for (let i = 0; i < 24; i++) {
        // Pad hours with leading zero if necessary
        let hours = i.toString().padStart(2, "0");
        timeOptions.push(`${hours}:00`);
    }

    useEffect(() => {
        if (roleAccess) {
            if (![ROLE_ACCESS_CODES.code_363, ROLE_ACCESS_CODES.code_364].some(role => roleAccess.includes(role))) {
                setIsDisabled((prev) => ({
                    ...prev,
                    spacialSlaField: true,
                }));
            }
        }
    }, [roleAccess]);

    //default Settings Time
    useEffect(() => {
        setSpacialSlaValue(stateData?.rowdata?.preference_value || "");
        setInitialValue(stateData?.rowdata?.preference_value || "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateData?.rowdata?.preference_type_id]);

    const isDisableButton = useMemo(() => {
        return initialValue === spacialSlaValue;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue, spacialSlaValue]);

    //  Create the padded string with spaces
    const generatePaddedString = (value, totalLength) => {
        value = String(value);
        const spacesNeed = totalLength - value.length;
        const paddedString = " ".repeat(spacesNeed) + value;

        return paddedString;
    };
    const preferenceTypeId = stateData?.rowdata?.preference_type_id || ""; // Fallback to empty string if undefined
    const paddedString = generatePaddedString(preferenceTypeId, 10);
    const gethistoryTableData = async () => {
        try {
            setIsLoading(true);
            let res = await getCustomerPreferenceHistory(
                stateData?.mainDistrictId,
                selectedCustomer?.id,
                paddedString
            );
            if (res && res.data) {
                // Ensure res.data is an array with at least two elements
                let resultSetOne = res.data[0];
                let resultSetTwo = res.data[1];
                let resultSetOneMap = new Map(
                    resultSetOne.map((item) => [item.change_history_id, item])
                );
                let updatedData = resultSetTwo.map((item) => {
                    const historyData = resultSetOneMap.get(item.change_history_id);
                    const dateFormate = dateTimeFormatByLocalewithSeconds(
                        historyData?.change_history_datetime,
                        localeByBranch
                    );
                    return {
                        ...historyData,
                        ...item,
                        date: dateFormate,
                        imEmployee: `${historyData?.employee_last_name} ${historyData?.employee_first_name} `,
                        authorizedBy: `${historyData?.personnel_last_name} ${historyData?.personnel_first_name} `,
                        previousValue: item?.old_value,
                        newValue: item?.new_value
                    };
                });
                updatedData.sort((a, b) => {
                    const dateA = new Date(a.change_history_datetime);
                    const dateB = new Date(b.change_history_datetime);
                    return dateB - dateA; // Descending order
                });
                setTableData(updatedData);
            }
            setIsLoading(false);
        } catch (e) {
            let message = handleSystemErrorDataDogLog(e);
            setThrowErrorMessage(message);
            setThrowError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handeSettingTimeChange = (e) => {
    const val = e.target.value;
    const min = 120;
    const max = stateData.rowdata.preference_type_id === preferencesTypeIds.criticalSpacialSla ? 720 : 1440;

    // Allows an empty string OR a number that MUST start with 1-9
    if (val === "" || /^[1-9][0-9]*$/.test(val)) {
        if (val === "") {
            setSpacialSlaValue(val);
            setThrowErrorMessage("");
            setValidationFalied(false);
            setThrowError(false);
        } else if (Number(val) < min) {
            setSpacialSlaValue(val);
            setThrowErrorMessage(t("preferences.spacialSla.error", { min: min, max: max }));
            setThrowError(true);
            setValidationFalied(true);
        } else if (Number(val) > max) {
            setSpacialSlaValue(val);
            setThrowErrorMessage(t("preferences.spacialSla.error", { min: min, max: max }));
            setThrowError(true);
            setValidationFalied(true);
        } else {
            setSpacialSlaValue(val);
            setThrowErrorMessage("");
            setThrowError(false);
            setValidationFalied(false);
        }
    }
};



    // xml creation
    const createXmlPayload = () => {
        const settingTimes = spacialSlaValue;

        const objectValues = `<ObjectValue Object_Id="${preferenceTypeId}" Object_Value="${settingTimes}" Version=""/>`;

        return `
      <ObjectValues>${objectValues}</ObjectValues>
    `;
    };
    const xmlPayload = createXmlPayload();
    const personnelId = isAuthenticated
        ? defaultAuthBranchValues?.personnel_id
        : "";
    // onSaveUpdatePreference handler
    const onSaveUpdatePreference = async () => {
        try {
            setIsLoading(true);
            let res = await updateCustomerPreferences(
                stateData?.mainDistrictId,
                selectedCustomer?.id,
                systemId,
                stateData?.employee_id,
                xmlPayload,
                personnelId
            );
            if (res) {
                setExpanded(false);
                dispatch(setIsRefreshRequired(true));
                if (stateData?.customer_id) {
                    if (Number(res.data[0][0]?.error).length > 0) {
                        let errorMsg = await getMessageFromCode(errorMsgs.errorCode59028);

                        setThrowErrorMessage(
                            errorMsg[0]?.descr || findErrorMessage(ERROR_TYPES.ISSUE)
                        );

                        setThrowError(true);
                    } else {
                        setInitialValue(spacialSlaValue);
                        if (stateData?.customer_id) {
                            await getPreferenceTabValues(
                                stateData?.mainDistrictId,
                                stateData?.customer_id
                            );
                        }
                        let errorMsg = await getMessageFromCode(errorMsgs.errorCode64095);

                        let replacedText = errorMsg[0]?.descr.replace(
                            "|",
                            t(`preferences.spacialSla.title.${stateData.rowdata.preference_type_id ? stateData.rowdata.preference_type_id : preferencesTypeIds.criticalSpacialSla}`)
                        );
                        await import(`dayjs/locale/${localeByBranch}.js`);
                        const formattedDate = dayjs
                            .utc()
                            .add(timeZoneOffset, "hour")
                            .locale(localeByBranch)
                            .format(dayMonthYearTimeFormat);
                        const replaceWithDate = replacedText.replace("|", formattedDate);
                        setSuccessMessage(
                            replaceWithDate || findErrorMessage(ERROR_TYPES.ISSUE)
                        );
                        setSuccess(true);
                    }
                }
            }
            setIsLoading(false);
        } catch (e) {
            let message = handleSystemErrorDataDogLog(e);
            setThrowErrorMessage(message);
            setThrowError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const onChangeAccordionExpand = async (e, expanded) => {
        if (!expanded) {
            return;
        }
        await gethistoryTableData();
    };


    return (
        <>
            <PreferencesLayout>
                {isLoading && <CircularLoaderFullPage loading={isLoading} />}
                {success && (
                    <SuccessPopup message={successMessage} close={setSuccess} />
                )}
                {throwError && (
                    <Collapse in={throwError}>
                        <Alert
                            severity="error"
                            icon={<img src={ErrorIcon} alt="error" />}
                            action={
                                <IconButton
                                    aria-label={t("common.close")}
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setThrowError(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {throwErrorMessage}
                        </Alert>
                    </Collapse>
                )}

                <Box mb={spacing.verticalMargin20}>
                    <Typography variant="subtitle1" color="textSecondary">
                        {t("common.customer")}
                    </Typography>
                    <Typography variant="subtitle1">
                        {selectedCustomer?.number?.trim()}
                    </Typography>
                </Box>

                <Box sx={PreferencesStyles.borderBottom}></Box>
                <br />
                <Grid container spacing={2}>
                    <Grid item md={6} lg={3} xs={12}>
                        <FormControl fullWidth variant="outlined">
                            <>
                                <TextField
                                    type="text"
                                    label={t("preferences.spacialSla.txtBoxPlaceHolder")}
                                    disabled={isDisabled.spacialSlaField}
                                    value={spacialSlaValue}
                                    onChange={handeSettingTimeChange}
                                    inputProps={{
                                        inputMode: 'numeric'
                                    }}
                                />
                            </>
                        </FormControl>
                    </Grid>
                </Grid>
                <br />
                <Box> {t(`preferences.spacialSla.discription.${stateData.rowdata.preference_type_id ? stateData.rowdata.preference_type_id : 1000}`)}</Box>
                <br />
                <Box sx={PreferencesStyles.borderBottom}></Box>
                <br />

                <Accordion
                    sx={PreferencesStyles.accordian}
                    expanded={expanded}
                    onChange={(e, newExpanded) => {
                        setExpanded(newExpanded);
                        onChangeAccordionExpand(e, newExpanded);
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography
                            variant="subtitle1"
                            style={PreferencesStyles.subTitleStyle}
                        >
                            {t("preferences.history")}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer>
                            <MUIDataTable
                                columns={AddCutOffDeadlineTableColumns}
                                options={tableOptions(tableData)}
                                data={tableData}
                            />
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
                <Box sx={PreferencesStyles.borderBottom}></Box>
                <br />
                <Box sx={PreferencesStyles.buttonStyles}>
                    <Button
                        variant="outlined"
                        type="submit"
                        onClick={redirecToPreviousPage}
                    >
                        <ChevronLeftIcon /> {t("common.back")}
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={
                            validationFailed ||
                            ![ROLE_ACCESS_CODES.code_363, ROLE_ACCESS_CODES.code_364].some(role => roleAccess.includes(role)) ||
                            isDisableButton
                        }
                        onClick={onSaveUpdatePreference}
                    >
                        {t("common.save")}
                    </Button>
                </Box>
                <br />
            </PreferencesLayout>
        </>
    );
};

export default SpacialSla;
